const englishTranslations = {
  mainTitle: "Write a Prompt, Spark a World",
  subtitle: "The first text-to-60second animation in 720p, perfect to share with friends!",
  // Text prompt card
  promptTitle: "Enter Book Title",
  promptSubtitle: "What story do you want to bring to life?",
  bookPlaceholder: "e.g., The Secret Garden",
  chooseStyle: "Choose Style",
  // Inspiration feature
  needInspiration: "Need inspiration?",
  selectGenre: "Select a genre",
  fantasy: "Fantasy",
  scienceFiction: "Science Fiction",
  mystery: "Mystery",
  romance: "Romance",
  historicalFiction: "Historical Fiction",
  getIdea: "Get Idea",
  loadingIdea: "Finding inspiration...",
  // Steps
  bookTitle: "Book Title",
  style: "Style",
  email: "Email",
  // Style picker
  styleTitle: "Choose Your Style",
  styleSubtitle: "Select the animation style for your creation",
  continueButton: "Continue",
  backButton: "Back",
  // Email checkout
  checkoutTitle: "Your Magical Creation",
  checkoutSubtitle: "Complete your order to bring your imagination to life",
  yourEmail: "Your Email",
  emailPlaceholder: "you@example.com",
  validationMessage: "Please enter a valid email address",
  orderItem: "60 second video in {style} Style",
  deliveryTime: "Delivery Time:",
  deliveryTimeValue: "45-55 minutes",
  total: "Total:",
  getAnimation: "Get My Animation",
  securePayment: "Secure payment processed by Stripe",
  
  // Video carousel
  seeTheMagic: "See the Magic in Action",
  
  // Disclaimer
  disclaimer: "Disclaimer: This platform is an independent creative tool designed for artistic expression through the use of generative AI. While the visual or thematic outputs may occasionally resemble styles seen in popular media or animation, this product is not affiliated with, endorsed by, or connected to any animation studio, entertainment brand, or intellectual property holder.",
  originality: "All videos, images, characters, and scenes generated through this platform are original creations, produced using AI models and prompts provided by users. We do not use or incorporate any copyrighted characters, storylines, artwork, audio, or names from existing intellectual properties in any default system prompt or model behavior.",
  intellectualProperty: "All copyrights, trademarks, and third-party intellectual properties referenced or indirectly evoked by users remain the sole property of their respective owners.",
  userResponsibility: "Users are solely responsible for:",
  promptsSubmitted: "The prompts they submit,",
  contentGenerated: "The content they choose to generate,",
  contentUsage: "And any resulting use, distribution, or publication of AI-generated outputs.",
  liability: "We do not assume liability for any content generated, misused, shared, or distributed in a way that may violate intellectual property rights, terms of service, or applicable law. This platform is intended for original storytelling, artistic experimentation, and personal enjoyment only.",

  // Add these new blog translations
  ourBlog: 'Blog',
  backToHome: 'Back to Home',
  backToBlog: 'Back to All Posts',
  allPosts: 'View All Posts',
  blogTitle: 'Magical Stories & Insights',
  blogIntro: 'Welcome to our enchanted blog, where we share the magic behind AI storytelling, creative tips, and the latest in text-to-video technology.',
};

export default englishTranslations; 